<template>
  <div
    v-click-outside="clickOutsideHandler"
    :class="[
      $style.searchProviderFilter,
      $style[position],
      { [$style.searchProviderFilterWithShadow]: selected.length >= 1 },
    ]"
  >
    <BitBottomSheetHeader
      :class="$style.searchProviderMobHeader"
      :title="filterTitle || components.search.searchFilterProviderTitle"
      @close="closeProvidersFilter"
    />
    <ul
      :class="[
        $style.searchProviderFilterList,
        { [$style.searchProviderFilterListWithSelected]: selected.length >= 1 },
      ]"
    >
      <!-- <li
        v-if="filters.length != selected.length && filters.length > selected.length"
        :class="[$style.searchProviderFilterListItem, $style.searchProviderFilterListItemFirst]"
      >
        <div :class="$style.searchProviderFilterLabel">
          <BitCheckbox
            v-model="selectedAll"
            :readonly="selectedAll"
            :label-text="components.search.searchFilterProviderAllTitle"
          >
            <template #prependInputIcon>
              <AllProviderIcon />
            </template>
          </BitCheckbox>
          <span
            v-if="selected.length != 0 && !isCataloguePage"
            :class="$style.searchProviderFilterReset"
            @click="resetFilterAll"
          >
            {{ components.search.searchFilterProviderResetTitle }}
          </span>
        </div>
      </li> -->
      <!-- <li
        v-if="selected.length >= 1 && !gamePageSearch"
        :class="[$style.searchProviderFilterListItem, $style.searchProviderFilterListItemSelected]"
      >
        <FilterChipsBlock :class="$style.searchProviderFilterListItemSelectedHolder">
          <BitChipsTabButton
            v-for="name in selected"
            :key="name"
            @click="removeSelectProviderByName(name)"
          >
            {{ name }}
          </BitChipsTabButton>
        </FilterChipsBlock>
      </li> -->
      <li v-for="item in filters" :key="item.value" :class="$style.searchProviderFilterListItem">
        <BitCheckbox
          v-model="selected"
          :class="$style.searchProviderFilterCheckbox"
          :value="item.value"
        >
          <template #label>
            <div :class="$style.searchProviderFilterLabel">
              <img :class="$style.searchProviderFilterIcon" :src="item.icon" alt="icon" />
              <span :class="$style.searchProviderFilterTitle">{{ capitalize(item.title) }}</span>
              <span :class="$style.searchProviderFilterListNumber">{{ item.limit }}</span>
            </div>
          </template>
        </BitCheckbox>
      </li>
    </ul>
    <div v-if="selected.length != 0" :class="$style.searchProviderFilterShadow">
      <BitButton
        type="secondary"
        is-fluid-width
        :class="$style.searchProviderFilterClearAll"
        @click="resetFilterAll"
      >
        {{ components.search.searchFilterProviderResetTitle }}
      </BitButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BitCheckbox, BitBottomSheetHeader, BitButton } from '@bit/ui-kit';
import { computed, ref, watch } from 'vue';
import { useStoreComponents } from '~/stores/strapi/components';
import { useStoreProviders } from '~/stores/strapi/providers';
import clickOutside from '~/utils/directives/vClickOutside';

const props = defineProps({
  providers: {
    type: Object as PropType<Record<string, number>>,
    required: true,
  },
  selectedProviders: {
    type: Array as PropType<string[]>,
    required: true,
  },
  position: {
    type: String as PropType<'top' | 'bottom'>,
    default: 'bottom',
  },
  gamePageSearch: {
    type: Boolean,
    default: false,
  },
  isCataloguePage: {
    type: Boolean,
    default: false,
  },
  filterTitle: {
    type: String,
    default: '',
  },
});
const emit = defineEmits<{
  (e: 'selected', value: string[]): void;
  (e: 'close'): void;
}>();

const vClickOutside = clickOutside;

const components = useStoreComponents();
const storeProviders = useStoreProviders();

const selected = ref(props.selectedProviders);
const selectedAll = ref(!props.selectedProviders.length);

const providersIconList = computed(() => {
  return storeProviders.activeList.reduce((result, item) => {
    result[item.providerId] = item.providerIcon?.url || '';
    return result;
  }, {} as Record<string, string>);
});

const filters = computed(() =>
  Object.keys(props.providers)
    .sort()
    .map((provider) => {
      const providerTitle =
        storeProviders.activeList.find((providerStore) => providerStore.providerId === provider)
          ?.providerTitle || provider;
      return {
        title: providerTitle,
        limit: `(${props.providers[provider]})`,
        value: provider,
        icon:
          providersIconList.value[provider] ||
          `/image-cdn/ss/logos/providers_small/color/${provider}.svg`,
      };
    })
);

const closeProvidersFilter = () => {
  emit('close');
};

// const removeSelectProviderByName = (name: string) => {
//   const index = selected.value.findIndex((selectedName) => name === selectedName);

//   if (index > -1) {
//     selected.value.splice(index, 1);
//   }
// };

const resetFilterAll = () => {
  selectedAll.value = true;
};

const capitalize = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const clickOutsideHandler = () => {
  if (props.isCataloguePage) {
    emit('close');
  }
};

watch(
  selected,
  (value) => {
    if (value.length) {
      selectedAll.value = false;
    }

    if (value.length === 0) {
      selectedAll.value = true;
    }

    emit('selected', selected.value);
  },
  { deep: true }
);

watch(selectedAll, (value) => {
  if (value) {
    selected.value = [];
  }
});
</script>

<style lang="scss" module src="./searchProviderFilter.scss"></style>
